/* * @Author: LiaoYingLong * @Date: 2018-08-08 18:46:22 * @Last Modified by:
LiaoYingLong * @Last Modified time: 2018-08-17 11:37:29 */

<template>
  <div id="footer">
    <div class="top wrapper-center">
      <dl class="tel">
        <img src="./u301.png" />
        <dt>客服热线</dt>
        <dd>400-111-8130</dd>
        <dt>全国商务合作热线</dt>
        <dd>4001118130-3</dd>
      </dl>
      <ul class="ul">
        <li v-for="item in list" :key="item.name" class="group-name">
          <dt>{{ item.name }}</dt>
          <dd
            v-for="chItem in item.children"
            :key="chItem.name"
            @click="clickItem(chItem)"
          >
            {{ chItem.name }}
          </dd>
        </li>
      </ul>
      <div class="qr-code">
        <dt>关注亿车</dt>
        <img src="./qr-code.png" width="120" height="120" />
        <dd>扫码关注官方微信</dd>
      </div>
    </div>
    <div class="yJcontent_name" @click="handleClick()">
      <span>智能硬件</span>
    </div>
    <div class="copy-right wrapper-center">
      Copyright ©2014-2018 Ecaray. All Rights Reserved.
      深圳市前海亿车科技有限公司
      <a
        href="http://beian.miit.gov.cn"
        style="color:#fff;text-decoration:none;"
        >粤ICP备15027635号</a
      >
      版权所有
    </div>
  </div>
</template>
<script>
import { getProTree } from '@/api/portal';
export default {
  data() {
    return {
      productTree: [],
      id: '',
      list: [
        {
          name: '解决方案',
          children: [
            { name: '领航版', url: '/Solve/Pilotage' },
            { name: '巡航版', url: '/Solve/cruise' },
            { name: '启航版', url: '/Solve/Setsail' },
          ],
        },
        {
          name: '产品中心',
          children: [
            // { name: '静态交通数据服务', url: '' },
            {
              name: '城市智慧停车运营',
              url: '/product/cuntry',
              query: { active: 5 },
            },
            {
              name: '封闭式停车场管理',
              url: '/product/operation',
              query: { active: 1 },
            },
            {
              name: '新能源充电桩管理',
              url: '/product/newenergy',
              query: { active: 1 },
            },
          ],
        },
        {
          name: '服务合作',
          children: [
            // { name: '车主服务', url: '' },
            // { name: '开放平台', url: '' },
            { name: '蜜蜂停车', url: '/parkbees' },
            { name: '停车经营', url: '/parking' },
          ],
        },

        {
          name: '关于我们',
          children: [
            { name: '亿车介绍', url: '/about/recomment' },
            { name: '新闻中心', url: '/news' },
            { name: '企业文化', url: '/about/cultrue' },
            { name: '亿车视频', url: '/about/video' },
            { name: '加入亿车', url: '/about/joinus' },
            { name: '联系我们', url: '/connect' },
          ],
        },
      ],
    };
  },
  methods: {
    clickItem(item) {
      const { url, query } = item;
      if (!url) return;
      if (url.includes('http')) {
        window.location.href = url;
        return;
      }
      this.$router.push({
        path: url,
        query,
      });
    },
    _getprotree() {
      getProTree({})
        .then(res => {
          this.productTree = res.data[0].id;
          this.id = this.productTree;
        })
        .catch(err => {});
    },
    handleClick() {
      this.$router.push({
        path: '/product/znYj',
        query: { id: this.id },
      });
    },
  },
  created() {
    this._getprotree();
  },
};
</script>

<style lang="scss">
#footer {
  .wrapper-center {
    width: 1176px;
    margin: 0 auto;
  }
  dd,
  dt {
    cursor: pointer;
  }
  background-color: #0f2346;
  color: #fff;
  padding-top: 64px;
  font-weight: normal;
  font-stretch: normal;
  .top {
    display: flex;
    padding-bottom: 24px;
    .tel {
      width: 300px;
      white-space: nowrap;
      margin-right: -5px;
      dt {
        opacity: 0.48;
        font-size: 16px;
        cursor: auto;
      }
      dd {
        font-size: 20px;
        margin-top: 8px;
        margin-bottom: 35px;
        cursor: auto;
      }
    }
    .ul {
      display: flex;
      .group-name {
        width: 200px;
        &:last-child {
          margin-right: 90px;
        }
        dt {
          font-size: 18px;
          opacity: 0.96;
          margin-bottom: 24px;
          cursor: auto;
        }
        dd {
          font-size: 14px;
          opacity: 0.64;
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .qr-code {
      margin-left: -128px;
      dt {
        font-size: 18px;
        opacity: 0.96;
        margin-bottom: 36px;
        text-align: center;
        cursor: auto;
      }
      dd {
        font-size: 14px;
        opacity: 0.64;
        margin-top: 18px;
      }
    }
  }
  .copy-right {
    font-size: 12px;
    opacity: 0.64;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.16);
    height: 80px;
    line-height: 80px;
  }
  .yJcontent_name {
    font-size: 14px;
    opacity: 0.64;
    width: 400px;
    margin: 0 auto;
    position: relative;
    left: 106px;
    top: -148px;
    cursor: pointer;
  }
}
</style>
